<template>
  <div class="custom-container">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="faktura page-wrapp">
      <div v-for="post in posts" class="post-item" :key="post._id">
        <div v-if="displayed">
          <v-alert
            text
            dense
            color="red accent-2"
            border="left"
            icon="mdi-alert-octagon"
            class="text-left"
          >
            {{ post.servicemessage }}
          </v-alert>
        </div>
      </div>
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <div
          class="d-flex flex-direction-row justify-space-between align-center mb-5"
        >
          <div class="label pb-0 mb-0">Faktura</div>
          <div>
            <template v-if="selectItems && selectItems.length > 2">
              <v-select
                v-model="selectAccount"
                :items="selectItems"
                item-text="label"
                item-value="value"
                label="Dine kontoer"
                outlined
                v-on:change="changeAccount"
                hide-details
              ></v-select>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="label">Faktura</div>
        <div class="mb-5">
          <template v-if="selectItems && selectItems.length > 2">
            <v-select
              v-model="selectAccount"
              :items="selectItems"
              item-text="label"
              item-value="value"
              label="Dine kontoer"
              outlined
              v-on:change="changeAccount"
              hide-details
            ></v-select>
          </template>
        </div>
      </template>

      <div class="invoices">
        <v-expansion-panels
          v-if="selectedInvoicesList && selectedInvoicesList.length"
        >
          <v-expansion-panel
            v-for="(item, key) in selectedInvoicesList"
            :key="key"
            class="invoice"
          >
            <v-expansion-panel-header>
              <div class="invoice-header">
                <div class="mobile-details">
                  <span>{{
                    getMonth(new Date(item.invoiceDate).getMonth())
                  }}</span>
                  <span>{{ item.amount.toFixed(2) }} kr</span>
                </div>

                <span class="name">{{
                  getMonth(new Date(item.invoiceDate).getMonth())
                }}</span>

                <span class="amount">{{ item.amount.toFixed(2) }} kr</span>

                <div class="duedate">
                  <span v-if="item.status === 6">Betalt</span>
                  <span v-else-if="item.type === 'Credited'">Kreditert</span>
                  <span v-else-if="item.type === 'CreditNote'">Kreditnota</span>
                  <span v-else-if="item.type === 'Reminder'">Purring</span>
                  <span v-else-if="item.type === 'Dunning'">Inkasso</span>
                  <span
                    v-else-if="
                      item.type === 'DunningCompleted' ||
                      item.type === 'Dunning completed'
                    "
                    >Inkasso avsluttet</span
                  >

                  <div
                    v-else-if="
                      !item.type ||
                      item.type === 'Invoiced' ||
                      item.type === 'invoiced'
                    "
                  >
                    <span v-if="item.status === 1">Sender</span>
                    <span v-else-if="item.status === 2">
                      <v-icon>mdi-clock-alert-outline</v-icon>
                      <span>{{
                        $moment(item.dueDate).format('DD') +
                        '. ' +
                        getMonth(new Date(item.dueDate).getMonth())
                      }}</span></span
                    >
                    <span v-else-if="item.status === 5">Delvis Betalt</span>
                    <span v-else-if="item.status === 0">Ikke opprettet</span>
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="invoice-details">
                <div class="details-item">
                  <span>Gjenstående Beløp</span>
                  <span
                    >{{
                      item.restAmount ? item.restAmount.toFixed(2) : 0
                    }}
                    kr</span
                  >
                  <!-- <span @click="copy(item.amount)">
										<v-icon>fa-copy</v-icon>
										<span>Kopier</span>
									</span> -->
                </div>
                <div class="details-item">
                  <span>Kid</span>
                  <span>{{ item.kid }}</span>
                  <span></span>
                  <!-- <span @click="copy(item.kid)">
										<v-icon>fa-copy</v-icon>
										<span>Kopier</span>
									</span> -->
                </div>
                <div class="details-item">
                  <span>Konto</span>
                  <span>{{ bankNumber }}</span>
                  <span></span>
                  <!-- <span @click="copy(item.konto)">
										<v-icon>fa-copy</v-icon>
										<span>Kopier</span>
									</span> -->
                </div>
                <div class="details-item">
                  <span>Frist</span>
                  <span>{{
                    $moment(item.dueDate).format('DD') +
                    '. ' +
                    getMonth(new Date(item.dueDate).getMonth()) +
                    ' ' +
                    $moment(item.dueDate).format('yyyy')
                  }}</span>
                  <span></span>
                </div>
                <div class="details-item">
                  <span>Status</span>
                  <template
                    v-if="
                      !item.type ||
                      item.type === 'invoiced' ||
                      item.type === 'Invoiced'
                    "
                  >
                    <span v-if="item.status === 1">Ikke sendt</span>
                    <span v-else-if="item.status === 2">Ikke betalt</span>
                    <span v-else-if="item.status === 5">Delvis Betalt</span>
                    <span v-else-if="item.status === 6">Betalt</span>
                  </template>
                  <span v-else-if="item.type === 'Credited'">Kreditert</span>
                  <span v-else-if="item.type === 'CreditNote'">Kreditnota</span>
                  <span v-else-if="item.type === 'Reminder'">Purring</span>
                  <span v-else-if="item.type === 'Dunning'">Inkasso</span>
                  <span
                    v-else-if="
                      item.type === 'DunningCompleted' ||
                      item.type === 'Dunning completed'
                    "
                    >Inkasso avsluttet</span
                  >
                  <span></span>
                </div>
              </div>
              <div v-if="computer" class="invoice-actions">
                <v-btn @click="download(item.pdf)" color="primary"
                  >Last ned faktura</v-btn
                >
              </div>
              <div v-else class="invoice-actions">
                <v-btn @click="download2(item.pdf)" color="primary"
                  >Vis fakturadetaljer</v-btn
                >
                <!-- <v-btn>Utsett forfallsdato</v-btn> -->
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <p v-else class="empty-error">
          Du har ingen fakturaer på MinSide enda. Den første kommer i løpet av
          få dager.
        </p>
      </div>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" v-on:click="snackbar = false">
            Lukke
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import './Faktura.scss';
import { account, invoices, invoicePdf } from '../../api/common';
// import { account, invoicePdf } from "../../api/common";
import { getNorwayMonth } from '../../utils/date';
import './Faktura.scss';

const query = `*[_type == "mypageServiceMessage"]{
  _id,
	servicemessage,
	displayed,
}`;

export default {
  name: 'Faktura',

  components: {},

  data() {
    return {
      android: false,
      balance: 0,
      computer: false,
      iPhone: false,
      iPad: false,
      loading: true,
      posts: [],
      displayed: false,
      loader: false,
      invoicesList: [],
      selectedInvoicesList: [],
      bankNumber: '',
      snackbar: false,
      snackbarText: '',
      selectAccount: '',
      selectItems: [],
      selectedAccount: [],
      token: localStorage.getItem('customToken'),
    };
  },
  created() {
    this.fetchData();
    this.detectUserAgent();
  },
  async mounted() {
    await this.getDataFromApi();

    if (
      this.$router &&
      this.$router.currentRoute &&
      this.$router.currentRoute.params &&
      this.$router.currentRoute.params.guid
    ) {
      this.selectAccount = this.$router.currentRoute.params.guid;
      this.changeAccount();
    }

    this.bankNumber = localStorage.bankNumber;
  },

  methods: {
    detectUserAgent() {
      if (/iPhone/.test(navigator.userAgent)) {
        this.iPhone = true;
      } else if (/iPad/.test(navigator.userAgent)) {
        this.iPad = true;
      } else if (navigator.maxTouchPoints >= 1) {
        this.iPad = true;
      } else if (/Android/.test(navigator.userAgent)) {
        this.android = true;
      } else {
        this.computer = true;
      }
    },
    openPdf(url) {
      console.log('link', url);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      const file = url;

      const token = localStorage.getItem('customToken');
      const headers = new Headers();
      headers.append('Authorization', `Bearer ${token}`);

      fetch(file, { headers })
        .then((response) => response.blob())
        .then((blobby) => {
          let objectUrl = window.URL.createObjectURL(blobby);

          anchor.href = objectUrl;
          anchor.download = 'Faktura.pdf';
          anchor.click();

          window.URL.revokeObjectURL(objectUrl);
        });
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;

      this.$sanity.fetch(query).then(
        (posts) => {
          this.loading = false;
          this.posts = posts;
          this.displayed = posts[0].displayed;
        },
        (error) => {
          this.error = error;
        }
      );
    },
    async getDataFromApi() {
      this.loader = true;
      this.invoicesList = [];
      this.selectItems = [{ label: 'Se alle', value: '' }];
      this.selectAccount = '';
      this.accounts = [];

      try {
        let tmpAccounts = await account();

        tmpAccounts = tmpAccounts.data.Accounts;
        tmpAccounts.forEach((item) => {
          let accountAddress =
            item.Addresses && item.Addresses.length > 0
              ? item.Addresses[0]
              : '';
          accountAddress = accountAddress
            ? (
                (accountAddress.StreetName || '') +
                ' ' +
                (accountAddress.BuildingNumber || '') +
                ' ' +
                (accountAddress.CityName || '')
              ).trim()
            : '';
          let accountName = item.Name ? item.Name : accountAddress;
          this.selectItems.push({ label: accountName, value: item.Guid });
          this.accounts.push(this.decorateAccount(item));
        });

        let tmpInvoices = await invoices();
        // let tmpInvoices = [];
        let allInvoices = [];

        // Test data
        // tmpInvoices = require("./tmpInvoices.json");

        if (tmpInvoices.data && tmpInvoices.data.length > 0) {
          tmpInvoices.data.forEach((InvoiceBalance) => {
            this.balance = InvoiceBalance.balance;
          }),
            tmpInvoices.data.forEach((invoicesAccount) => {
              if (
                invoicesAccount.invoices &&
                invoicesAccount.invoices.length > 0
              ) {
                invoicesAccount.invoices.forEach((invoice) => {
                  let modifiedInvoice = Object.assign({}, invoice);
                  modifiedInvoice.konto = invoicesAccount.accountGuid;
                  allInvoices.push(modifiedInvoice);
                });
              }
            });
        }

        tmpInvoices = allInvoices;

        tmpInvoices
          .filter(
            (item) =>
              item.status === 2 || item.status === 6 || item.status === 5
          )
          .forEach((item) => {
            this.invoicesList.push(this.decorateInvoice(item));
          });

        this.changeAccount();
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = 'Feil ved innlasting av data';
      }

      this.loader = false;
    },

    changeAccount() {
      if (this.selectAccount) {
        let tmp = this.accounts.filter(
          (item) => item.Guid == this.selectAccount
        );
        tmp = tmp && tmp.length > 0 ? [tmp[0]] : this.accounts;

        this.selectedAccount = [];
        this.selectedAccount = [...tmp];
      } else {
        this.selectedAccount = [];
        this.selectedAccount = [...this.accounts];
      }

      this.selectedInvoicesList = [];
      this.selectedAccount.forEach((item) => {
        this.invoicesList.forEach((subitem) => {
          if (subitem.konto == item.Guid) {
            this.selectedInvoicesList.push(Object.assign({}, subitem));
          }
        });
      });

      this.selectedInvoicesList = this.selectedInvoicesList.sort(
        (a, b) =>
          this.$moment(b.invoiceDate).format('YYYYMMDDHHmmss') -
          this.$moment(a.invoiceDate).format('YYYYMMDDHHmmss')
      );
    },

    decorateAccount(item) {
      let decoratedAccount = Object.assign({}, item);
      decoratedAccount.mobile = (item.Communication.filter(
        (com) => com.Channel == 'Mobile'
      ) || [{ Value: '' }])[0].Value;
      decoratedAccount.email = (item.Communication.filter(
        (com) => com.Channel == 'Email'
      ) || [{ Value: '' }])[0].Value;
      decoratedAccount.address = (item.Addresses || [{}])[0];
      return decoratedAccount;
    },

    decorateInvoice(item) {
      let decoratedInvoice = Object.assign({}, item);
      return decoratedInvoice;
    },

    getMonth(month) {
      return getNorwayMonth(month);
    },

    download(url) {
      invoicePdf(url).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
        // window.open(file, )
        window.postMessage(link);
        console.log('window.postMessage', window.postMessage(link));
      });
    },

    download2(url) {
      invoicePdf(url).then((res) => {
        const token = res.config.headers.Authorization;
        const url = res.config.url;
        const data = `${token},${url}`;
        window.ReactNativeWebView.postMessage(data);
      });
    },

    copy(text) {
      navigator.clipboard.writeText(text);
    },
  },
};
</script>
